const KeyboardShortcuts = {
  CreatePost: {
    key: "mod+enter",
    name: "Create Post/Comment"
  },
  GoToAccount: { key: "g+p", name: "Go to Account" },
  GoToBookmarks: { key: "g+b", name: "Go to Bookmarks" },
  GoToExplore: { key: "g+e", name: "Go to Explore" },
  GoToHome: { key: "g+h", name: "Go to Home" },
  GoToNotifications: { key: "g+n", name: "Go to Notifications" },
  GoToSearch: { key: "g+s", name: "Go to Search" },
  GoToSettings: { key: "g+t", name: "Go to Settings" },
  ThisModal: { key: "?", name: "Shortcut help" }
} as const;

export type ShortcutName = keyof typeof KeyboardShortcuts;
export default KeyboardShortcuts;
